<template>
  <div class="upload">
    <a-upload-dragger
      v-model:file-list="fileList"
      name="img-file"
      :multiple="false"
      :showUploadList="false"
      :action="`/img-trans/upload-image2${query}`"
      @change="onChange"
    >
      <div v-if="field.value" :style="{ 'background-image': `url(${field.value})` }" class="preview"></div>
      <div v-else class="pt-4 pb-4">
        <loading-outlined v-if="loading"></loading-outlined>
        <template v-else>
          <UploadOutlined class="mr-1" />
          <p class="text-3">{{ config.placeholder || '点击或拖动图片到此区域进行上传' }}</p>
        </template>
      </div>
    </a-upload-dragger>
  </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import { UploadOutlined, LoadingOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { props } from './helper';

export default defineComponent({
  props,
  components: { UploadOutlined, LoadingOutlined },
  setup(props) {
    const fileList = ref([]);
    const loading = ref(false);
    const onChange = e => {
      console.log(111, e);
      const { status, response } = e.file;
      loading.value = status === 'uploading';

      if (status === 'done' && response) {
        const { sourceUrl } = response;
        if (sourceUrl) {
          props.handleChange(sourceUrl);
          message.success('上传成功');
        } else {
          message.error('上传失败');
        }
      }
    };

    const query = process.env.NODE_ENV === 'development' ? '?xiangji=2021-10-01' : '';
    return {
      query,
      fileList,
      onChange,
      loading,
    };
  },
});
</script>
<style lang="less" scoped>
.upload {
  > span {
    display: block;
    width: 100%;
  }
  ::v-deep(.ant-upload-select) {
    width: 100%;
  }
  ::v-deep(.ant-upload-btn) {
    padding: 0;
  }
}
.preview {
  width: 100%;
  height: 0;
  padding: 100% 0 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
